export { default } from './ProductFooter';
